import { PlenaryStudioVersionHistoryPage } from '@hendrx/core/plenary/pages/PlenaryStudioVersionHistoryPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/studio/plenary/edit/$plenaryDraftId/versions/$plenarySnapshotId')({
  component: RouteComponent
});

function RouteComponent() {
  const { plenaryDraftId, plenarySnapshotId } = Route.useParams();
  return <PlenaryStudioVersionHistoryPage plenaryDraftId={plenaryDraftId} plenarySnapshotId={plenarySnapshotId} />;
}
